import React from 'react'
import ReactDOM from 'react-dom'

// Components
import Dialog from 'Components/Dialog'
import ThemeProvider from 'Components/ThemeProvider'

const NavConfirmation = (message, callback) => {
  const container = document.createElement('div')
  container.setAttribute('custom-confirmation-navigation', '')

  document.body.appendChild(container)

  const closeModal = (callbackState) => {
    ReactDOM.unmountComponentAtNode(container)
    callback(callbackState)
  }

  ReactDOM.render(
    <ThemeProvider>
      <Dialog
        actionButtonText="OK"
        cancelButtonText="Cancel"
        onAction={() => closeModal(true)}
        onClose={() => closeModal(false)}
        open
        text={message}
        title="Leave Current Page?"
      />
    </ThemeProvider>,
    container,
  )
}

export default NavConfirmation
